// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const MAP_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  CLASSIFICATION_MODE: 'map.classificationMode',
  SCALE_RANGE_MIN: 'map.scaleRange.min',
  SCALE_RANGE_MAX: 'map.scaleRange.max',
  LABEL_ENABLED: 'map.label.enabled',
  LABEL_FONT_SIZE: 'map.label.fontSize',
  LABEL_FONT_FACE_BOLD: 'map.label.fontFace.bold',
  LABEL_FONT_FACE_ITALIC: 'map.label.fontFace.italic',
  LABEL_COLOR: 'map.label.color',
  LABEL_SCALE_RANGE_MIN: 'map.label.scaleRange.min',
  LABEL_SCALE_RANGE_MAX: 'map.label.scaleRange.max',
  LABEL_TEXT_EFFECT: 'map.label.textEffect',
  LABEL_VISIBILITY_MODE: 'map.label.visibilityMode',
  MAPTIP_ENABLED: 'map.maptip.enabled',
  MAPTIP_FORMAT: 'map.maptip.format',
  LEGEND_ENABLED: 'map.legend.enabled',
  LINE_SECTION_ENABLED: 'map.line.section.enabled',
  LINE_SYMBOLIZATION: 'map.line.symbolization',
  LINE_STYLE: 'map.line.style',
  LINE_WIDTH: 'map.line.width',
  LINE_START: 'map.line.start',
  LINE_START_SYMBOLIZATION: 'map.line.start.symbolization',
  LINE_START_IMAGE_REPOSITORY: 'map.line.start.image.repository',
  LINE_START_IMAGE_CONTENT_IDENTIFIER: 'map.line.start.image.contentIdentifier',
  LINE_START_IMAGE_SIGNATURE: 'map.line.start.image.signature',
  LINE_START_SIZE: 'map.line.start.size',
  LINE_END: 'map.line.end',
  LINE_END_SYMBOLIZATION: 'map.line.end.symbolization',
  LINE_END_IMAGE_REPOSITORY: 'map.line.end.image.repository',
  LINE_END_IMAGE_CONTENT_IDENTIFIER: 'map.line.end.image.contentIdentifier',
  LINE_END_IMAGE_SIGNATURE: 'map.line.end.image.signature',
  LINE_END_SIZE: 'map.line.end.size',
  LINE_OFFSET: 'map.line.offset',
  LINE_IMAGE_REPOSITORY: 'map.line.image.repository',
  LINE_IMAGE_CONTENT_IDENTIFIER: 'map.line.image.contentIdentifier',
  LINE_IMAGE_SIGNATURE: 'map.line.image.signature',
  LINE_MARKER_ENABLED: 'map.lineMarker.enabled',
  LINE_MARKER_IMAGE_REPOSITORY: 'map.lineMarker.image.repository',
  LINE_MARKER_IMAGE_CONTENT_IDENTIFIER: 'map.lineMarker.image.contentIdentifier',
  LINE_MARKER_IMAGE_SIGNATURE: 'map.lineMarker.image.signature',
  LINE_MARKER_AT_LINE_START: 'map.lineMarker.atLineStart',
  LINE_MARKER_AT_LINE_MIDDLE: 'map.lineMarker.atLineMiddle',
  LINE_MARKER_AT_LINE_END: 'map.lineMarker.atLineEnd',
  LINE_MARKER_AT_LINE_VERTICES: 'map.lineMarker.atLineVertices',
  LINE_MARKER_AT_SEGMENT_MIDDLE: 'map.lineMarker.atSegmentMiddle',
  LINE_MARKER_AT_REGULAR_INTERVAL: 'map.lineMarker.atRegularInterval',
  LINE_MARKER_REGULAR_INTERVAL_SIZE: 'map.lineMarker.regularIntervalSize',
  LINE_MARKER_SIGNATURE_TYPE: 'map.lineMarker.signatureType',
  LINE_MARKER_SIZE: 'map.lineMarker.size',
  LINE_MARKER_COLOR: 'map.lineMarker.color',
  LINE_MARKER_ALIGN_WITH_LINE: 'map.lineMarker.alignWithLine',
  LINE_MARKER_OFFSET: 'map.lineMarker.offset',
  FILL_ENABLED: 'map.fill.enabled',
  FILL_STYLE: 'map.fill.style',
  FILL_BACKGROUND_COLOR: 'map.fill.backgroundColor',
  FILL_SYMBOLIZATION: 'map.fill.symbolization',
  FILL_IMAGE_REPOSITORY: 'map.fill.image.repository',
  FILL_IMAGE_CONTENT_IDENTIFIER: 'map.fill.image.contentIdentifier',
  FILL_IMAGE_SIGNATURE: 'map.fill.image.signature',
  BORDER_ENABLED: 'map.border.enabled',
  BORDER_WIDTH: 'map.border.width',
  BORDER_COLOR: 'map.border.color',
  BORDER_STYLE: 'map.border.style',
  BORDER_SYMBOLIZATION: 'map.border.symbolization',
  BORDER_IMAGE_REPOSITORY: 'map.border.image.repository',
  BORDER_IMAGE_CONTENT_IDENTIFIER: 'map.border.image.contentIdentifier',
  BORDER_IMAGE_SIGNATURE: 'map.border.image.signature',
  POINT_ROTATION: 'map.point.rotation',
  POINT_ROTATION_ENABLED: 'map.point.rotation.enabled',
  POINT_SYMBOLIZATION: 'map.point.symbolization',
  POINT_SHAPE: 'map.point.shape',
  POINT_IMAGE_REPOSITORY: 'map.point.image.repository',
  POINT_IMAGE_CONTENT_IDENTIFIER: 'map.point.image.contentIdentifier',
  POINT_IMAGE_SIGNATURE: 'map.point.image.signature',
  POINT_SIZE: 'map.point.size',
  OPACITY: 'map.polygon.opacity',
  PIE_CHART_SIZE: 'map.pieChart.size',
  PIE_CHART_VALUE_LABELS: 'map.pieChart.valueLabels',
  PIE_CHART_SHOW_TOTALS: 'map.pieChart.showTotals',
  HEATMAP_OPACITY: 'map.heatmap.opacity',
  HEATMAP_GRADIENT: 'map.heatmap.gradient',
  HEATMAP_GRADIENT_REVERSE: 'map.heatmap.gradient.reverse',
  HEATMAP_RADIUS_VALUE: 'map.heatmap.radius.value',
  HEATMAP_RADIUS_UNIT: 'map.heatmap.radius.unit',
  HEATMAP_COMPRESSION: 'map.heatmap.compression',
  HEATMAP_GRADIENT_TRANSPARENCY_ENABLED: 'map.heatmap.gradient.transparency.enabled',
  MAP_PIE_CHART_MAX_MEASURES: 'map.pieChart.maxMeasures',
  INFO_WINDOW_DESCRIPTION: 'map.infoWindow.description',
  INFO_WINDOW_ATTRIBUTE: 'map.infoWindow.attribute',
  QUERY_RESULT_GEOMETRY_VERTEX_LIMIT: 'map.query.result.geometry.vertex.Limit',
  PIE_CHART_STABLE_MIN_VALUE: 'map.pieChart.stableMinValue',
  PIE_CHART_STABLE_MAX_VALUE: 'map.pieChart.stableMaxValue'
} as const;

/** @see net/disy/cadenza/workbook/model/MapDataViewSettingsKey.java */
export type MapDataViewSettingsKey = keyof typeof MAP_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const MapDataViewSettingsKey = {
  values: Object.keys(MAP_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly MapDataViewSettingsKey[],
  toPersistenceKey: (value: MapDataViewSettingsKey) => MAP_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = MapDataViewSettingsKey.values.find(key => MAP_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No MapDataViewSettingsKey for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>

/**
 * Values for the key MapDataViewSettingsKey 'PIE_CHART_SIZE'.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/map/web/visualization/config/PieChartSize.java
 */
export const PIE_CHART_SIZE = {
  CONSTANT: 'constant',
  PROPORTIONAL: 'proportional'
};

/**
 * Values for the key MapDataViewSettingsKey 'PIE_CHART_VALUE_LABELS'.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/map/web/visualization/config/PieChartValueLabels.java
 */
export const PIE_CHART_VALUE_LABELS = {
  NONE: 'none',
  VALUE: 'value',
  PERCENTAGE: 'percentage'
};

/**
 * Values for the key MapDataViewSettingsKey 'HEATMAP_RADIUS_UNIT'.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/map/web/visualization/config/HeatmapRadiusUnits.java
 */
export const HEATMAP_RADIUS_UNITS = [
  'kilometers',
  'meters',
  'pixels'
];
